module.exports = __webpack_public_path__ + "static/media/6880.01f8644c.jpg";